<template>
    <div id="app">
        <topfrom v-show="ismobile === 0"></topfrom>
        <topfrommobile v-show="ismobile === 1"></topfrommobile>
        <!-- <keep-alive> -->
        <router-view class="router" />
        <!-- </keep-alive> -->
        <btnav v-show="ismobile === 0"></btnav>
        <footermobile v-show="ismobile === 1"></footermobile>
    </div>
</template>

<script>
import btnav from '@/components/footer';
import topfrom from '@/components/topfrom';
import topfrommobile from '@/components/mobile/topfrom_mobile'
import footermobile from './components/mobile/footer_mobile.vue';
export default {
    components: { btnav, topfrom, topfrommobile, footermobile },
    data() {
        return {
            routing: true,
            isRouterAlive: true,
            ismobile: 0
        };
    },
    provide() {
        //提供
        return {
            reload: this.reload,
        };
    },
    created() {
        this.isMobile()
    },
    mounted() {
        // if (this.$route.path.indexOf('/details') != -1) {
        //     this.routing = false;
        // } else {
        //     this.routing = true;
        // }
        // window.addEventListener('beforeunload', (e) => {
        //     window.scroll(0, 0);
        // });
        // document.documentElement.scrollTop = 870;
    },
    watch: {
        // $route(newValue) {
        //     if (newValue.path.indexOf('/details') != -1) {
        //         this.routing = false;
        //     } else {
        //         this.routing = true;
        //     }
        // },
    },
    methods: {
        isMobile() {
            let userAgentInfo = navigator.userAgent;
            let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
            let getArr = Agents.filter((i) => userAgentInfo.includes(i));
            if (getArr.length > 0) {
                this.$router.push('/main/index2_mobile');
                this.ismobile = 1;
            } else {
                this.$router.push('/');
            }
        },
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true;
            });
        },
    },
};
</script>

<style>
.router {
    min-height: 680rem;
}

@media screen and (max-width: 1400rem) {
    body {
        overflow-x: hidden;
    }

    .router {
        min-height: auto;
        /* margin-bottom: 20rem; */
    }
}

html {
    scroll-behavior: smooth;
}

body {
    margin: 0;
    padding: 0;
    /* background: rgba(250, 251, 254, 1); */
    background: #fff;
    transition: opacity 500ms;

    scroll-behavior: smooth;
    /* overflow: hidden; */
}

::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 8rem;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1rem;
}

::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    box-shadow: inset 0 0 5rem rgba(97, 184, 179, 0.1);
    background: #004a9a;
}

::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5rem rgba(87, 175, 187, 0.1);
    border-radius: 10rem;
    background: #ededed;
}
</style>



// WEBPACK FOOTER //
// src/App.vue